import React, { createContext, useContext, useState } from "react";

export const content = {
  fr: {
    nav: { home: "Accueil", services: "Nos Services", about: "À Propos", projects: "Nos Projets", blog: "Blog & Actualités", contact: "Contact" },
    hero: {
      tag: "Smart Aircraft — Luxembourg",
      l1: "L'expertise",
      l2: "vue du ciel.",
      sub: "Chez Fixedrone, nous sommes votre partenaire dédié à la détection par image et données. Découvrez notre savoir-faire, nos compétences et notre engagement au service de vos projets.",
      cta: "Discuter d'un projet",
      cta2: "Explorer les services",
      scroll: "Défiler",
    },
    marquee: ["DÉTECTION PAR IMAGE", "DONNÉES", "PRÉCISION", "ALTITUDE", "PHOTOGRAMMÉTRIE", "THERMIQUE"],
    manifestoTitle: "Notre approche",
    manifestoLead: "Nous transformons chaque vol en données exploitables. Une méthode, quatre convictions.",
    manifesto: [
      { n: "01", t: "L'expertise vue du ciel", d: "Nous captons ce que l'œil humain ne voit pas — depuis la bonne altitude, au bon moment, avec la précision d'un pilote certifié." },
      { n: "02", t: "De l'image à la donnée", d: "Chaque prise de vue devient une mesure : orthophotographie, modèle 3D, calcul de cubature. La donnée guide vos décisions." },
      { n: "03", t: "La sécurité d'abord", d: "Le drone accède là où l'humain prend des risques. Structures hautes, toitures, parois — sans échafaudage ni nacelle." },
      { n: "04", t: "Un accompagnement sur mesure", d: "Notre approche personnalisée garantit des solutions innovantes et efficaces, alignées sur vos objectifs de durabilité et de rentabilité." },
    ],
    servicesTag: "Nos Services",
    servicesTitle: "Nos solutions énergétiques et aériennes",
    servicesLead: "Fixedrone propose une gamme complète de services conçus pour répondre aux défis uniques des entreprises et des collectivités.",
    services: [
      {
        key: "energie", label: "Solutions énergétiques",
        short: "Conseil en énergie durable, personnalisé et rentable.",
        desc: "Une gamme complète de services de conseil en énergie durable, conçus pour répondre aux défis uniques des entreprises et des collectivités. Notre approche personnalisée garantit des solutions innovantes alignées sur vos objectifs de durabilité et de rentabilité.",
        points: ["Audit énergétique aérien", "Inspection thermique d'installations", "Contrôle de panneaux photovoltaïques", "Stratégie durable sur mesure"],
      },
      {
        key: "chantier", label: "Suivi de chantier",
        short: "Documenter l'évolution du projet de façon incontestable.",
        desc: "L'usage le plus courant pour documenter l'évolution du projet. Reporting périodique, topographie de précision, inspection technique et valorisation marketing de votre savoir-faire.",
        groups: [
          { t: "Suivi de progression & Reporting", items: ["Photos et vidéos aériennes périodiques", "Timelapse aérien aux mêmes coordonnées GPS", "Rapports d'avancement pour clients/investisseurs"] },
          { t: "Topographie & Cartographie", items: ["Orthophotographie 2D haute résolution à l'échelle", "Modélisation 3D (jumeau numérique BIM)", "Calcul de cubature des stocks et déblais"] },
          { t: "Inspection technique & Sécurité", items: ["Inspection de structures hautes sans échafaudage", "Inspection thermique (ponts thermiques, fuites)", "Surveillance des périmètres de sécurité"] },
          { t: "Communication & Marketing", items: ["Vues immersives FPV pour les réseaux", "Insertion paysagère du projet 3D"] },
        ],
      },
      {
        key: "carriere", label: "Carrière et gravier",
        short: "Cartographie, cubature et suivi d'exploitation.",
        desc: "Le drone survole le site pour créer des plans ultra-précis, mesurer les stocks et aider à la décision stratégique tout en surveillant l'impact environnemental.",
        groups: [
          { t: "Topographie & Cartographie", items: ["Orthophotographie géoréférencée de la carrière", "Modèle Numérique de Terrain (MNT)", "Courbes de niveau pour la planification"] },
          { t: "Gestion des Stocks (Cubature)", items: ["Mesure automatique de volumes de granulats", "Inventaire financier précis à une date T"] },
          { t: "Suivi d'Exploitation", items: ["Suivi des fronts de taille", "Optimisation des pistes de circulation", "Détection de fissures et risques d'éboulement"] },
          { t: "Environnement & Réhabilitation", items: ["Surveillance de la biodiversité et poussières", "Modélisation 3D du plan de remise en état"] },
        ],
      },
      {
        key: "inspection", label: "Inspection",
        short: "Toitures, façades et structures — sans échelle ni risque.",
        desc: "L'usage qui évite de sortir échelles et échafaudages. Contrôle de couverture, analyse thermique infrarouge, diagnostic de façades et aide aux devis par photogrammétrie.",
        groups: [
          { t: "Inspection de la Toiture", items: ["Repérage de tuiles cassées ou poreuses", "Vérification de la zinguerie et gouttières", "Détection de fissures sur souches et Velux"] },
          { t: "Analyse Thermique (IR)", items: ["Détection des ponts thermiques", "Localisation d'infiltrations d'eau", "Contrôle de panneaux photovoltaïques (hot spots)"] },
          { t: "Façades & Structures Hautes", items: ["Diagnostic de micro-fissures et enduit", "Inspection des combles par l'extérieur", "Détection de nids de frelons et nuisibles"] },
          { t: "Aide aux Travaux & Devis", items: ["Métrés précis par photogrammétrie 3D", "Suivi de chantier avant/après"] },
        ],
      },
      {
        key: "agriculture", label: "Agriculture et faune",
        short: "Agriculture de précision et protection de la faune.",
        desc: "Cartographie de la vigueur des cultures, protection de la faune par caméra thermique et traitements spécifiques biologiques.",
        groups: [
          { t: "Agriculture de Précision", items: ["Cartographie NDVI (santé des plantes)", "Modulation de l'apport en intrants", "Comptage de pieds et levée de semis", "Détection du stress hydrique"] },
          { t: "Protection de la Faune", items: ["Sauvetage des faons avant fauchage (thermique)", "Recensement des populations de gibier", "Suivi des dégâts pour indemnisation"] },
          { t: "Traitements Spécifiques", items: ["Lutte biologique contre la pyrale du maïs", "Blanchiment de serres", "Sursemis et couverts végétaux"] },
        ],
      },
    ],
    quote: "L'expertise de Fixedrone a transformé notre approche des données. Leurs conseils précis et leur accompagnement sur mesure ont été essentiels pour nos chantiers.",
    quoteAuthor: "Client — Secteur BTP",
    contact: {
      tag: "Contactez Fixedrone",
      title: "Parlons de votre projet.",
      lead: "Un chantier à suivre, une inspection à mener, une carrière à cartographier ? Écrivez-nous.",
      name: "Nom", email: "Email", company: "Entreprise", subject: "Sujet", message: "Votre message",
      send: "Envoyer la demande", sending: "Envoi...",
      ok: "Demande enregistrée. Nous vous recontacterons rapidement.",
      err: "Une erreur est survenue. Réessayez.",
      addressT: "Adresse", hoursT: "Horaires d'ouverture", contactT: "Contact",
      address: ["6D, Route de Trèves,", "Senningerberg,", "L-2633, Luxembourg"],
      hours: ["Du lundi au vendredi : 9h – 17h", "Samedi & Dimanche : Fermé"],
    },
    footerCta: "Travaillons",
    footerCta2: "ensemble",
    rights: "Tous droits réservés.",
  },
  en: {
    nav: { home: "Home", services: "Services", about: "About", projects: "Projects", blog: "Blog & News", contact: "Contact" },
    hero: {
      tag: "Smart Aircraft — Luxembourg",
      l1: "Expertise",
      l2: "from the sky.",
      sub: "At Fixedrone, we are your dedicated partner for image and data detection. Discover our know-how, our skills and our commitment to your projects.",
      cta: "Start a project",
      cta2: "Explore services",
      scroll: "Scroll",
    },
    marquee: ["IMAGE DETECTION", "DATA", "PRECISION", "ALTITUDE", "PHOTOGRAMMETRY", "THERMAL"],
    manifestoTitle: "Our approach",
    manifestoLead: "We turn every flight into actionable data. One method, four convictions.",
    manifesto: [
      { n: "01", t: "Expertise from the sky", d: "We capture what the human eye cannot — from the right altitude, at the right time, with the precision of a certified pilot." },
      { n: "02", t: "From image to data", d: "Every shot becomes a measurement: orthophotography, 3D model, volume calculation. Data drives your decisions." },
      { n: "03", t: "Safety first", d: "The drone reaches where humans take risks. High structures, roofs, walls — no scaffolding, no lift." },
      { n: "04", t: "Tailored support", d: "Our personalized approach guarantees innovative, efficient solutions aligned with your sustainability and profitability goals." },
    ],
    servicesTag: "Our Services",
    servicesTitle: "Our energy & aerial solutions",
    servicesLead: "Fixedrone offers a complete range of services designed to meet the unique challenges of businesses and communities.",
    services: [
      {
        key: "energie", label: "Energy solutions",
        short: "Sustainable energy consulting — tailored and profitable.",
        desc: "A complete range of sustainable energy consulting services, designed to meet the unique challenges of businesses and communities. Our personalized approach guarantees innovative solutions aligned with your goals.",
        points: ["Aerial energy audit", "Thermal inspection of installations", "Photovoltaic panel control", "Tailored sustainability strategy"],
      },
      {
        key: "chantier", label: "Site monitoring",
        short: "Document project progress in an indisputable way.",
        desc: "The most common use to document project progress. Periodic reporting, precision topography, technical inspection and marketing of your expertise.",
        groups: [
          { t: "Progress tracking & Reporting", items: ["Periodic aerial photos and videos", "Aerial timelapse at fixed GPS coordinates", "Progress reports for clients/investors"] },
          { t: "Topography & Mapping", items: ["High-res 2D orthophotography to scale", "3D modeling (BIM digital twin)", "Volume calculation of stocks & earthworks"] },
          { t: "Technical inspection & Safety", items: ["High structure inspection without scaffolding", "Thermal inspection (thermal bridges, leaks)", "Security perimeter monitoring"] },
          { t: "Communication & Marketing", items: ["Immersive FPV views for social media", "Landscape integration of the 3D project"] },
        ],
      },
      {
        key: "carriere", label: "Quarry & gravel",
        short: "Mapping, volume measurement and operation monitoring.",
        desc: "The drone flies over the site to create ultra-precise plans, measure stocks and support strategic decisions while monitoring environmental impact.",
        groups: [
          { t: "Topography & Mapping", items: ["Georeferenced orthophotography of the quarry", "Digital Terrain Model (DTM)", "Contour lines for planning"] },
          { t: "Stock management (Volume)", items: ["Automatic aggregate volume measurement", "Precise financial inventory at a given date"] },
          { t: "Operation monitoring", items: ["Quarry face progress tracking", "Traffic lane optimization", "Crack and collapse risk detection"] },
          { t: "Environment & Rehabilitation", items: ["Biodiversity and dust monitoring", "3D modeling of the restoration plan"] },
        ],
      },
      {
        key: "inspection", label: "Inspection",
        short: "Roofs, facades and structures — no ladder, no risk.",
        desc: "The use that avoids ladders and scaffolding. Roof control, infrared thermal analysis, facade diagnosis and quote support through photogrammetry.",
        groups: [
          { t: "Roof inspection", items: ["Spotting broken or porous tiles", "Checking zinc work and gutters", "Detecting cracks on chimneys and skylights"] },
          { t: "Thermal analysis (IR)", items: ["Thermal bridge detection", "Water infiltration localization", "Photovoltaic panel control (hot spots)"] },
          { t: "Facades & High structures", items: ["Micro-crack and coating diagnosis", "Attic inspection from outside", "Hornet nest and pest detection"] },
          { t: "Works & Quote support", items: ["Precise measurements via 3D photogrammetry", "Before/after site monitoring"] },
        ],
      },
      {
        key: "agriculture", label: "Agriculture & wildlife",
        short: "Precision farming and wildlife protection.",
        desc: "Crop vigor mapping, wildlife protection with thermal cameras and specific biological treatments.",
        groups: [
          { t: "Precision Agriculture", items: ["NDVI mapping (plant health)", "Modulation of input application", "Plant counting and seedling emergence", "Water stress detection"] },
          { t: "Wildlife Protection", items: ["Fawn rescue before mowing (thermal)", "Game population census", "Damage tracking for compensation"] },
          { t: "Specific Treatments", items: ["Biological control of corn borer", "Greenhouse whitening", "Overseeding and cover crops"] },
        ],
      },
    ],
    quote: "Fixedrone's expertise transformed our approach to data. Their precise advice and tailored support were essential for our projects.",
    quoteAuthor: "Client — Construction sector",
    contact: {
      tag: "Contact Fixedrone",
      title: "Let's talk about your project.",
      lead: "A site to monitor, an inspection to run, a quarry to map? Write to us.",
      name: "Name", email: "Email", company: "Company", subject: "Subject", message: "Your message",
      send: "Send request", sending: "Sending...",
      ok: "Request recorded. We will get back to you shortly.",
      err: "Something went wrong. Please try again.",
      addressT: "Address", hoursT: "Opening hours", contactT: "Contact",
      address: ["6D, Route de Trèves,", "Senningerberg,", "L-2633, Luxembourg"],
      hours: ["Monday to Friday: 9am – 5pm", "Saturday & Sunday: Closed"],
    },
    footerCta: "Let's work",
    footerCta2: "together",
    rights: "All rights reserved.",
  },
};

export const serviceImages = {
  energie: "https://images.unsplash.com/photo-1540380403593-2f4cbbc006dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  chantier: "https://images.unsplash.com/photo-1723107638733-16ef49e5d4de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  carriere: "https://images.unsplash.com/photo-1571223641822-b82408a0e705?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  inspection: "https://images.pexels.com/photos/6047506/pexels-photo-6047506.jpeg?auto=compress&cs=tinysrgb&w=1400",
  agriculture: "https://images.unsplash.com/photo-1619719826894-89d6c4fd5739?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const heroImage = "https://images.unsplash.com/photo-1544411047-c491e34a24e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
export const droneImage = "https://images.unsplash.com/photo-1576704075965-5293c1c31916?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const manifestoImage = "https://images.unsplash.com/photo-1723107638733-16ef49e5d4de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const t = content[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
